module.exports = __webpack_public_path__ + "img/iva_comprado.cbefbc64.png";